export default __webpack_public_path__ + "images/ae8be7265751c32a0625af32683763df-3-caring-connections.svg";